import type { AccessDeniedError } from "./errors"

type AccessDeniedListener = (error: AccessDeniedError) => void

const listeners = new Set<AccessDeniedListener>()

export function onAccessDenied(listener: AccessDeniedListener): () => void {
	listeners.add(listener)
	return () => {
		listeners.delete(listener)
	}
}

export function notifyAccessDenied(error: AccessDeniedError): void {
	for (const listener of listeners) listener(error)
}
